/**
 * Equatio - Math made digital
 *
 * Injects a probe script of its own to work out whether the page uses MathJax, and
 * gives it a fixed id — which incidentally makes the extension identifiable.
 * Observed on version 67.0.2.
 */
import { probeSelector } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';
const ID = 'hjngolefdpdnooamgdldlkjgmdcmcjnc';
export const equatio: ExtensionDefinition = {
  id: ID,
  name: 'Equatio - Math made digital',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 1_000_000,
  notes: 'An education extension, so its user base is largely students and teachers.',
  signals: [
    { id: 'dom-mathjax-check', kind: 'dom',
      description: 'Look for <script id="eq-discover-mathjax-check">, the MathJax detection script it injects.',
      weight: 1, run: () => probeSelector('#eq-discover-mathjax-check', { timeoutMs: 1500 }) },
  ],
};
